import { defineComponent as _defineComponent } from 'vue';
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-523b8fcf"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "courses"
};
const _hoisted_2 = ["onClick"];
const _hoisted_3 = ["src"];
const _hoisted_4 = {
  key: 0,
  class: "courses-dialog"
};
const _hoisted_5 = {
  class: "courses-dialog-content"
};
const _hoisted_6 = {
  class: "courses-dialog-content-info"
};
const _hoisted_7 = {
  class: "courses-dialog-content-info-choose"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://img2.qiuwenxinli.com/official-website/index/course-10.png"
}, null, -1));
const _hoisted_9 = {
  class: "courses-dialog-content-info-choose-item-tag",
  src: "https://img2.qiuwenxinli.com/official-website/index/course-choosed.png"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "https://img2.qiuwenxinli.com/official-website/index/course-11.png"
}, null, -1));
const _hoisted_11 = {
  class: "courses-dialog-content-info-choose-item-tag",
  src: "https://img2.qiuwenxinli.com/official-website/index/course-choosed.png"
};
const _hoisted_12 = ["disabled"];
import { ref } from "vue";
export default /*#__PURE__*/_defineComponent({
  __name: 'psychology-course',
  emits: ["toCourseDetails"],
  setup(__props, {
    emit: emits
  }) {
    const courseList = ["https://img2.qiuwenxinli.com/official-website/index/course-1.png", "https://img2.qiuwenxinli.com/official-website/index/course-2.png", "https://img2.qiuwenxinli.com/official-website/index/course-3.png", "https://img2.qiuwenxinli.com/official-website/index/course-4.png", "https://img2.qiuwenxinli.com/official-website/index/course-5.png", "https://img2.qiuwenxinli.com/official-website/index/course-6.png", "https://img2.qiuwenxinli.com/official-website/index/course-7.png", "https://img2.qiuwenxinli.com/official-website/index/course-8.png", "https://img2.qiuwenxinli.com/official-website/index/course-9.png"];
    var isShowChooseView = ref(false);
    var currentChooseIndex = ref(0);
    function clickItem(index) {
      if (index == 4) {
        isShowChooseView.value = true;
      } else {
        emits("toCourseDetails", (index + 1).toString());
      }
    }
    function clickDialogItem(index) {
      currentChooseIndex.value = index;
    }
    function clickDialogSubmit() {
      if (currentChooseIndex.value == 1) {
        emits("toCourseDetails", "5-1");
      } else {
        emits("toCourseDetails", "5-2");
      }
    }
    function hideChooseView() {
      isShowChooseView.value = false;
    }
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", _hoisted_1, [(_openBlock(), _createElementBlock(_Fragment, null, _renderList(courseList, (item, index) => {
        return _createElementVNode("div", {
          class: "courses-item",
          key: index,
          onClick: $event => clickItem(index)
        }, [_createElementVNode("img", {
          src: item
        }, null, 8, _hoisted_3)], 8, _hoisted_2);
      }), 64)), _unref(isShowChooseView) ? (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", {
        class: "courses-dialog-content-info-choose-item",
        onClick: _cache[0] || (_cache[0] = $event => clickDialogItem(1))
      }, [_hoisted_8, _withDirectives(_createElementVNode("img", _hoisted_9, null, 512), [[_vShow, _unref(currentChooseIndex) == 1]])]), _createElementVNode("div", {
        class: "courses-dialog-content-info-choose-item",
        onClick: _cache[1] || (_cache[1] = $event => clickDialogItem(2))
      }, [_hoisted_10, _withDirectives(_createElementVNode("img", _hoisted_11, null, 512), [[_vShow, _unref(currentChooseIndex) == 2]])])]), _createElementVNode("button", {
        class: "courses-dialog-content-info-submit",
        onClick: clickDialogSubmit,
        disabled: _unref(currentChooseIndex) == 0
      }, " 确 认 ", 8, _hoisted_12)]), _createElementVNode("img", {
        class: "courses-dialog-content-close",
        src: "https://img2.qiuwenxinli.com/official-website/index/course-close.png",
        onClick: hideChooseView
      })])])) : _createCommentVNode("", true)]);
    };
  }
});